module.exports = __webpack_public_path__ + "Lato-Light.90301aa07d780a098122.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Light.woff
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Light.woff
// module chunks = styles